/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateDeliverFeeGradeAmountReqVo } from './CreateDeliverFeeGradeAmountReqVo';
import {
    CreateDeliverFeeGradeAmountReqVoFromJSON,
    CreateDeliverFeeGradeAmountReqVoFromJSONTyped,
    CreateDeliverFeeGradeAmountReqVoToJSON,
    CreateDeliverFeeGradeAmountReqVoToJSONTyped,
} from './CreateDeliverFeeGradeAmountReqVo';

/**
 * 
 * @export
 * @interface CreateUpdateDeliverFeeInternationalReqVo
 */
export interface CreateUpdateDeliverFeeInternationalReqVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    warehouseId: number;
    /**
     * 运输方式
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    transportMethodId?: number;
    /**
     * 国际运费分组：1电商快递，2海运物流，3橙火服务，4韩国3PL
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    orderTypeGroup: number;
    /**
     * 起重起始值
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    startValue: number;
    /**
     * 起重最终值
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    endValue: number;
    /**
     * 步长
     * @type {number}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    stepSize: number;
    /**
     * 等级金额
     * @type {Array<CreateDeliverFeeGradeAmountReqVo>}
     * @memberof CreateUpdateDeliverFeeInternationalReqVo
     */
    gradeAmounts: Array<CreateDeliverFeeGradeAmountReqVo>;
}

/**
 * Check if a given object implements the CreateUpdateDeliverFeeInternationalReqVo interface.
 */
export function instanceOfCreateUpdateDeliverFeeInternationalReqVo(value: object): value is CreateUpdateDeliverFeeInternationalReqVo {
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('orderTypeGroup' in value) || value['orderTypeGroup'] === undefined) return false;
    if (!('startValue' in value) || value['startValue'] === undefined) return false;
    if (!('endValue' in value) || value['endValue'] === undefined) return false;
    if (!('stepSize' in value) || value['stepSize'] === undefined) return false;
    if (!('gradeAmounts' in value) || value['gradeAmounts'] === undefined) return false;
    return true;
}

export function CreateUpdateDeliverFeeInternationalReqVoFromJSON(json: any): CreateUpdateDeliverFeeInternationalReqVo {
    return CreateUpdateDeliverFeeInternationalReqVoFromJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeInternationalReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDeliverFeeInternationalReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'],
        'startValue': json['startValue'],
        'endValue': json['endValue'],
        'stepSize': json['stepSize'],
        'gradeAmounts': ((json['gradeAmounts'] as Array<any>).map(CreateDeliverFeeGradeAmountReqVoFromJSON)),
    };
}

export function CreateUpdateDeliverFeeInternationalReqVoToJSON(json: any): CreateUpdateDeliverFeeInternationalReqVo {
    return CreateUpdateDeliverFeeInternationalReqVoToJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeInternationalReqVoToJSONTyped(value?: CreateUpdateDeliverFeeInternationalReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'startValue': value['startValue'],
        'endValue': value['endValue'],
        'stepSize': value['stepSize'],
        'gradeAmounts': ((value['gradeAmounts'] as Array<any>).map(CreateDeliverFeeGradeAmountReqVoToJSON)),
    };
}

